import Icon from "../../components/icons";
import { useNavigate } from "react-router-dom";

const WORKSPACES = [
  {
    title: "Pro",
    description: "Manage clients, portfolios and wealth reporting.",
    action: "Open Pro",
    icon: "Pro",
    path: "/pro",
    featured: true
  },
  {
    title: "Tax Harvesting",
    description: "Review tax positions and harvesting opportunities.",
    action: "Open Tax Harvesting",
    icon: "Chart",
    path: "/tax-harvesting"
  },
  {
    title: "Estate Mapping",
    description: "Visualize ownership structures and estate relationships.",
    action: "Coming soon",
    icon: "Diagram",
    comingSoon: true
  }
];

const DashboardLanding = () => {
  const navigate = useNavigate();

  return (
    <main className="c-workspace-dashboard">
      <div className="c-workspace-dashboard__intro">
        <p className="c-workspace-dashboard__eyebrow">BULLTICK 360</p>
        <h1 className="c-workspace-dashboard__title">Choose a workspace</h1>
        <p className="c-workspace-dashboard__subtitle">
          Select the tools you want to use today.
        </p>
      </div>

      <div className="c-workspace-dashboard__grid">
        {WORKSPACES.map((workspace) => (
          <button
            type="button"
            key={workspace.title}
            className={`c-workspace-dashboard__card${workspace.featured ? " is-featured" : ""}`}
            disabled={workspace.comingSoon}
            onClick={() => navigate(workspace.path)}
          >
            <span className="c-workspace-dashboard__icon">
              <Icon name={workspace.icon} width={28} height={28} color={workspace.featured ? "#FFFFFF" : "#005774"} />
            </span>
            <span className="c-workspace-dashboard__card-content">
              <span className="c-workspace-dashboard__card-title">{workspace.title}</span>
              <span className="c-workspace-dashboard__card-description">{workspace.description}</span>
            </span>
            <span className="c-workspace-dashboard__action">
              {workspace.action} {!workspace.comingSoon && <span aria-hidden="true">→</span>}
            </span>
          </button>
        ))}
      </div>
    </main>
  );
};

export default DashboardLanding;
